import { createStore, compose, applyMiddleware } from "redux";
import { axios, thunk } from "./middlewares";
import reducers from "./reducers";

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  composeEnhancer(applyMiddleware(axios, thunk))
);

export default store;



// WEBPACK FOOTER //
// ./src/services/state/store.js